import { gql } from '@apollo/client';

export const ProductCourseMappings = gql`
  query productCourseMappings(
    $pageNumber: Int
    $pageSize: Int
    $search: String
    $productType: String
    $addedBy: String
  ) {
    productCourseMappings(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
      productType: $productType
      addedBy: $addedBy
    ) {
      mappings {
        id
        productCode
        productName
        courseCode
        courseId
        createdBy
        createdAt
        courseName
        lastModifiedDate
      }
      pageNumber
      pageSize
      totalCount
    }
  }
`;

export const ProductCourseMappingsFilters = gql`
  query productCourseMappingFilterOptions {
    productCourseMappingFilterOptions {
      createdBy
      productTypes
    }
  }
`;
